import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/leadActivitySagas";
import { ArrowIcon, Trash } from "../../../../assets/images/svg";
import FilterDropdown from "./FilterDropdown";
import DatePicker from "./DatePicker";

const FiltersList = () => {
  const dispatch = useDispatch();
  const filtersList = useSelector((state) => state.leadActivity.filtersList);
  const filterLoading = useSelector((state) => state.leadActivity.filterLoading);
  const startFromOptions = useSelector((state) => state.leadActivity.startFromOptions);

  const handleOrder = (index, direction) => {
    dispatch(actionCreators.changeOrder({ index, direction }));
  };

  return filtersList.map((elem, idx) => {
    const { start_from, date_by, filter_by, filter_by_values, selectedRequestDates } =
      elem.selectedFilters;

    return (
      <div key={"list" + idx} className="filters-list">
        <FilterDropdown
          title="Action"
          keyName="start_from"
          options={startFromOptions}
          selectedOption={elem.selectedFilters?.start_from}
          width="140px"
          index={idx}
          includeFilter={false}
        />
        {start_from.id !== "lead" ? (
          <FilterDropdown
            title={`${start_from.name} Date`}
            keyName="date_by"
            options={elem.date_by}
            selectedOption={date_by}
            index={idx}
            includeFilter={false}
            width="170px"
          />
        ) : null}
        <FilterDropdown
          title="Filters By"
          keyName="filter_by"
          options={elem.filter_by}
          selectedOption={filter_by || elem.filter_by[0]}
          index={idx}
          includeFilter={false}
          width="170px"
        />
        <FilterDropdown
          title={filter_by?.name || elem.filter_by[0]?.name}
          keyName="filter_by_values"
          width="170px"
          options={elem.filter_by_values}
          selectedOption={filter_by_values}
          index={idx}
          isLoading={filterLoading === idx}
          numberDisplayed={0}
          includeSelectAll
          enableOnly
        />
        <DatePicker
          startDate={selectedRequestDates.startDate}
          endDate={selectedRequestDates.endDate}
          index={idx}
          isLeadSelected={start_from.id === "lead"}
          zIndex={filtersList.length - idx}
        />

        <div className="filters-list__controls">
          <div className="order-controls">
            {idx !== 0 && (
              <ArrowIcon
                onClick={() => handleOrder(idx, "up")}
                disabled={idx === 0}
                className="order-controls__icon up"
              />
            )}
            {idx !== filtersList.length - 1 && (
              <ArrowIcon
                onClick={() => handleOrder(idx, "down")}
                disabled={idx === filtersList.length - 1}
                className="order-controls__icon down"
              />
            )}
          </div>

          <Trash
            className="trash-icon"
            onClick={() => dispatch(actionCreators.removeFiltersGroup(idx))}
          />
        </div>
      </div>
    );
  });
};

export default FiltersList;
